import _styled from "styled-components";
const _excluded = ["style", "statusColor"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { STATUS_COLORS, STATUS_COLORS_MAP } from './consts';
/**
 * A StatusColorIndicator
 * docs.
 */
const StatusColorIndicator = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      statusColor = STATUS_COLORS.BLUE
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, rest, {
    ref: ref,
    $_css: [{
      width: '6px',
      height: '40px',
      borderRadius: theme.borderRadius.small,
      backgroundColor: STATUS_COLORS_MAP[statusColor]
    }, style]
  }));
});
StatusColorIndicator.displayName = 'StatusColorIndicator';
StatusColorIndicator.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Status color */
  statusColor: PropTypes.oneOf(Object.values(STATUS_COLORS))
};
export default Object.assign(StatusColorIndicator, {
  COLORS: STATUS_COLORS
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "StatusColorIndicator___StyledDiv",
  componentId: "sc-smcmkl-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=StatusColorIndicator.js.map